import React from 'react'
import Link from 'gatsby-link'

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

import image1 from '../../layouts/images/project2/unsichtbar_05-1972.jpg'
import image2 from '../../layouts/images/project2/patient_wheelchair_09-1970.jpg'
import image3 from '../../layouts/images/project2/patient_dr_serie_12-1985.jpg'
import image4 from '../../layouts/images/project2/patient_serie_07-1998.gif'
import image5 from '../../layouts/images/project2/ACTIVE_tabletennis_1987.jpg'
import image6 from '../../layouts/images/project2/ACTIVE_1992_2006.jpg'
import image7 from '../../layouts/images/project2/FAMILY_052004.gif'
import image8 from '../../layouts/images/project2/AbbFAMILY2010.gif'
import image9 from '../../layouts/images/project2/Worker_01-1987+2011.jpg'

const ImagineeringDisabilityPage = () => (
    <div className="container">
        <div className="row">
            <div className="col-lg-5 project-info">
                <h3>Imagineering Dis/Ability</h3>
                <div className="project-content">
                    <p>Images are not just simple copies, they are social practices which can inform us about cultural production of the category dis-/ability. A series of images over time can be read as indicators for social and cultural processes of change.</p>
                    <p>According to Disability Studies 'dis-/ability' is a socially constructed process and needs to be seen as a differential category like gender, race and class.</p>
                    <p>An important part of how dis/abled bodies and people are perceived are prosthetics. Cultural technology research emphasises links between prosthetic technology, war, work and body optimisation utopias as well as experiences of destruction </p>
                    <p>The empirical study analyses images of physical disabled people on the basis of promotional material from the world’s leader of prosthetics and orthotics, Otto Bock. The research work is understood as the analysis of social conventions of normality and is situated in the cultural anthropological field of body politics research.</p>
                    <p>The analysed advertisement images from the 1950s until today articulate the change from exclusion and disregard (The Invisible Amputee), followed by the idea that disability is a malfunction (The Patient), followed by integration with the help of idealised utopia (The High-Performance Prosthetic User) towards an individualised human being with a lifestyle (The User with Lifestyle). Regarding prosthetic technology the research identifies the change from the idea that prosthetics are a replacement towards the idea of optimisation and value increase of the body.</p>
                    <p>Latest developments also show that with more advanced technology it becomes more difficult to determine the line of where the body ends and technology begins which brings up new ideas of normality and cultural shifts.</p>
                    <p>A further analysis of the material will be provided upon request.</p>
                </div>
            </div>

            <div className="col-lg-7">

                <ImageGallery
                    showThumbnails={false}
                    showFullscreenButton={false}
                    autoPlay={true}
                    items={[
                        { original: image1, },
                        { original: image2, },
                        { original: image3, },
                        { original: image4, },
                        { original: image5, },
                        { original: image6, },
                        { original: image7, },
                        { original: image8, },
                        { original: image9, }
                    ]} />

                <br />
                <br />

                <p className="project-blurb">A cultural anthropological research about the perception of disability in correlation with prosthetic technology.</p>

                <ul className="tags">
                    <li>Disability Studies</li>
                    <li>Cultural Technology Studies</li>
                    <li>Visual Culture</li>
                    <li>Visual Anthropology</li>
                    <li>Body Politics</li>
                    <li>Prosthetic Technology</li>
                    <li>Abductive Reasoning</li>
                    <li>Iconographical-Iconological Image-Discourse Analysis</li>
                </ul>

                <div className="footer-info">
                    <p><span className="highlight">Cooperation Partner:</span> WWU University Münster, Otto Bock Health Care</p>
                    <p><span className="highlight">Source:</span>Otto Bock archive with more than 1000 different promotional images of a 60 years investigation period</p>
                    <p><span className="highlight">Date:</span>December 2012 - October 2013</p>
                </div>
            </div>
        </div>
    </div>
)

export default ImagineeringDisabilityPage



// WEBPACK FOOTER //
// ./src/pages/projects/imagineering-dis-ability.js